import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Graficas } from "src/app/graficas/gestionGraficas/graficas.model";
import { sinSelloDeError } from "src/app/shared/http/sello-de-error";
import { UrlConstantes } from "src/app/utilerias/constantes/urlconstantes";

/** Lo que manda la pestaña: solo el periodo ("yyyy-MM-dd", ambos inclusivos). */
export interface IaDashboardReq {
  fechaIni: string;
  fechaFin: string;
}

/** Un renglon de "Ultimas solicitudes de IA" (SolicitudRecienteBean). */
export interface SolicitudReciente {
  idSolicitudIa: number;
  folio: string;
  nombreIa: string;
  area: string;
  estatus: string;
  /** "yyyy-MM-dd HH:mm". */
  fechaSolicitud: string;
}

/**
 * Resumen de gobernanza ISO/IEC 42001 (IaDashboardBean). Foto = sin
 * periodo; flujo = dentro del periodo. Las listas son {valor1, valor2}.
 */
export interface IaDashboard {
  activosActivos: number;
  activosInactivos: number;
  solicitudesPendientes: number;
  solicitudesSinResponsable: number;
  solicitudesPeriodo: number;
  aprobadas: number;
  rechazadas: number;
  horasADictamenPromedio: number;
  incidenciasAbiertas: number;
  incidenciasCriticas: number;
  activosSinMonitoreo: number;
  diasSinMonitoreo: number;
  proveedoresVigentes: number;
  proveedoresVencidos: number;
  solicitudesPorEstatus: Graficas[];
  incidenciasPorEstado: Graficas[];
  incidenciasPorGravedad: Graficas[];
  solicitudesPorMes: Graficas[];
  incidenciasPorMes: Graficas[];
  inventarioPorCicloVida: Graficas[];
  activosConIncidencias: Graficas[];
  solicitudesRecientes: SolicitudReciente[];
}

/** Un resumen en ceros, para arrancar la pestaña y para cuando el backend falla. */
export function iaDashboardVacio(): IaDashboard {
  return {
    activosActivos: 0,
    activosInactivos: 0,
    solicitudesPendientes: 0,
    solicitudesSinResponsable: 0,
    solicitudesPeriodo: 0,
    aprobadas: 0,
    rechazadas: 0,
    horasADictamenPromedio: 0,
    incidenciasAbiertas: 0,
    incidenciasCriticas: 0,
    activosSinMonitoreo: 0,
    diasSinMonitoreo: 120,
    proveedoresVigentes: 0,
    proveedoresVencidos: 0,
    solicitudesPorEstatus: [],
    incidenciasPorEstado: [],
    incidenciasPorGravedad: [],
    solicitudesPorMes: [],
    incidenciasPorMes: [],
    inventarioPorCicloVida: [],
    activosConIncidencias: [],
    solicitudesRecientes: [],
  };
}

/**
 * Pestaña "IA" del Dashboard de Inicio: un solo endpoint que devuelve el
 * resumen completo. El backend marca el error en los headers
 * (SelloDeError), y sinSelloDeError lo convierte en error de rxjs.
 */
@Injectable({
  providedIn: "root",
})
export class IaDashboardService {
  constructor(private http: HttpClient) {}

  dashboard(req: IaDashboardReq): Observable<IaDashboard> {
    return this.http
      .post<IaDashboard>(UrlConstantes.ISO42001_DASHBOARD, req, { observe: "response" })
      .pipe(sinSelloDeError("No fue posible cargar los indicadores de IA."));
  }
}
